import React from "react";
import Sugar from "sugar";

import ScorecardExpandablePanel from "./ScorecardExpandablePanel";

Sugar.extend();

function ScorecardDetailPanel({ children, fill, startOpen, className }) {
  return (
    <ScorecardExpandablePanel
      className={`scorecard-figure ${fill} ${className}`}
      startOpen={startOpen}
    >
      {children}

      <div className={["bottom-deco", fill].join(" ")}></div>
    </ScorecardExpandablePanel>
  );
}

ScorecardDetailPanel.defaultProps = {
  startOpen: false
};

export default ScorecardDetailPanel;
